var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 27,
    viewBox: "0 0 73 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4153 22.2038H27.4022L30.5353 3.71561H35.5489L32.4153 22.2038ZM23.185 3.71561L18.4057 16.432L17.8402 13.6936L17.8407 13.6946L16.1539 5.38027C16.1539 5.38027 15.95 3.71561 13.7759 3.71561H5.87494L5.78223 4.02866C5.78223 4.02866 8.19836 4.51134 11.026 6.14187L15.3813 22.2043H20.6045L28.5802 3.71561H23.185ZM62.6151 22.2038H67.2182L63.2048 3.71512H59.175C57.3142 3.71512 56.8609 5.09293 56.8609 5.09293L49.3843 22.2038H54.6101L55.6552 19.4576H62.028L62.6151 22.2038ZM57.0989 15.6639L59.7329 8.74518L61.2147 15.6639H57.0989ZM49.7763 8.16161L50.4917 4.19137C50.4917 4.19137 48.2842 3.38525 45.9829 3.38525C43.4952 3.38525 37.5875 4.42925 37.5875 9.5058C37.5875 14.2822 44.5212 14.3415 44.5212 16.8503C44.5212 19.3592 38.3019 18.9096 36.2494 17.3276L35.5041 21.4788C35.5041 21.4788 37.7425 22.5228 41.1625 22.5228C44.5835 22.5228 49.7444 20.8221 49.7444 16.1931C49.7444 11.3861 42.7484 10.9385 42.7484 8.84854C42.7489 6.75808 47.6311 7.02662 49.7763 8.16161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8407 13.6941L16.1539 5.37974C16.1539 5.37974 15.95 3.71509 13.7759 3.71509H5.87494L5.78223 4.02814C5.78223 4.02814 9.57974 4.78381 13.2222 7.6151C16.705 10.3213 17.8407 13.6941 17.8407 13.6941Z",
    fill: "#E6A540"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.7ff28bd2d916d22a7cda14ef674d1746.svg";
export { ForwardRef as ReactComponent };